/* cs-premium-v10.js — complementa cs-landing.js: entrada por scroll de reseñas y tarjetas "¿Le suena?"
   (no están en la lista de entradas del sistema) y micro-pop del precio del botón al cambiar de pack. */
(function () {
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function mark(sel, type) {
    var i = 0;
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.hasAttribute('data-cs-in')) return;
      el.setAttribute('data-cs-in', type);
      el.style.setProperty('--i', i++);
    });
  }
  function init() {
    mark('.cs-review', 'rise');
    mark('.cs-card', 'rise');
    var els = [].slice.call(document.querySelectorAll('.cs-review[data-cs-in]:not(.is-in), .cs-card[data-cs-in]:not(.is-in)'));
    if (REDUCE || !('IntersectionObserver' in window) || document.hidden) {
      els.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (list) {
        list.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { threshold: .15, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * .92 && r.bottom > 0) el.classList.add('is-in'); else io.observe(el);
      });
      /* red de seguridad: si por lo que sea no entran, se muestran a los 2,5 s */
      setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 2500);
    }
    var price = document.querySelector('[data-cs-main-atc] .cs-btn__price');
    if (price && !REDUCE && 'MutationObserver' in window) {
      new MutationObserver(function () {
        price.classList.remove('is-pop'); void price.offsetWidth; price.classList.add('is-pop');
      }).observe(price, { childList: true, characterData: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
